function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import request from '@/utils/request';

/**
 * 同步飞书产品库(全量同步？)
 */
export function skuSyncProductApi() {
  return request({
    url: "/admin/store/sku/sync/product",
    method: 'POST'
  });
}

/**
 * 导入修改指导价与默认价格
 */
export function uploadChangePriceApi(data) {
  return request({
    url: "/admin/store/sku/import/change/price",
    method: 'POST',
    data: data
  });
}

/**
 * 商品列表对外导出
 * @param params  列表筛选条件
 */
export function productOutApi(params) {
  var data = _objectSpread({}, params);
  var _ref = data.dateRange || [],
    _ref2 = _slicedToArray(_ref, 2),
    startTime = _ref2[0],
    endTime = _ref2[1];
  if (startTime && endTime) {
    data['startTime'] = startTime;
    data['endTime'] = endTime;
  }
  ;
  delete data.dateRange;
  return request({
    url: "/admin/export/excel/product/out",
    method: 'GET',
    params: data
  });
}

/**
 * 商品列表 导出
 * @param pram
 */
export function productExcelApi(params) {
  var data = _objectSpread({}, params);
  var _ref3 = data.dateRange || [],
    _ref4 = _slicedToArray(_ref3, 2),
    startTime = _ref4[0],
    endTime = _ref4[1];
  if (startTime && endTime) {
    data['startTime'] = startTime;
    data['endTime'] = endTime;
  }
  ;
  if (data.showCateId) {
    data.showCateId = data.showCateId.join(',');
  }
  ;
  delete data.dateRange;
  return request({
    url: "/admin/export/excel/sku",
    method: 'GET',
    params: data
  });
}

/**
 * 删除
 */
export function deleteByIdApi(params) {
  return request({
    url: "/admin/store/sku/deleteById",
    method: 'GET',
    params: params
  });
}

/**
 * 修改上下架
 */
export function updateStatusApi(params) {
  return request({
    url: "/admin/store/sku/updateStatus",
    method: 'GET',
    params: params
  });
}

/**
 * 修改上下架-供应商
 */
export function updateStatusApi2(params) {
  return request({
    url: "/admin/supplier/sku/updateStatus",
    method: 'GET',
    params: params
  });
}

/**
 * 修改库存
 */
export function updateStockApi(params) {
  console.log(params, 'params');
  return request({
    url: "/admin/store/sku/updateStock",
    method: 'GET',
    params: params
  });
}

/**
 * 修改排序
 */
export function updateSortApi(params) {
  return request({
    url: "/admin/store/sku/updateSort",
    method: 'GET',
    params: params
  });
}

/**
 * 修改采销状态
 */
export function updateCpStatusApi(params) {
  return request({
    url: "/admin/store/sku/updateCpStatus",
    method: 'GET',
    params: params
  });
}

/**
 * SKU分页列表
 */
export function skuListApi() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var params = _objectSpread({}, data);
  if (params.showCateId) {
    params.showCateId = params.showCateId.join(',');
  }
  var _ref5 = data.dateRange || [],
    _ref6 = _slicedToArray(_ref5, 2),
    startTime = _ref6[0],
    endTime = _ref6[1];
  if (startTime && endTime) {
    params['startTime'] = startTime;
    params['endTime'] = endTime;
  }
  ;
  delete params.dateRange;
  return request({
    url: "/admin/supplier/sku/list",
    method: 'GET',
    params: params
  });
}

/**
 * 产地
 */
export function getCityApi() {
  return request({
    url: "/admin/system/city/list/treeLevel3",
    method: 'GET'
  });
}
/**
 * 供应商
 */
export function getSupplierApi(params) {
  return request({
    url: "/admin/business/supplier/autoList",
    method: 'GET',
    params: params
  });
}
/**
 * 品牌 keyword
 */
export function getBrandrApi(params) {
  return request({
    url: "/admin/store/brand/autoList",
    method: 'GET',
    params: params
  });
}
/**
 * 商品标签 keyword
 */
export function getLabelApi(params) {
  return request({
    url: "/admin/store/label/autoList",
    method: 'GET',
    params: params
  });
}